(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSUnidadReceptoraDialogController', SSUnidadReceptoraDialogController);

    SSUnidadReceptoraDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'SSUnidadReceptora', 'SSSector', 'SSProyecto'];

    function SSUnidadReceptoraDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, SSUnidadReceptora, SSSector, SSProyecto) {
        var vm = this;

        vm.sSUnidadReceptora = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.sssectors = SSSector.query();
        vm.ssproyectos = SSProyecto.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.sSUnidadReceptora.id !== null) {
                SSUnidadReceptora.update(vm.sSUnidadReceptora, onSaveSuccess, onSaveError);
            } else {
                SSUnidadReceptora.save(vm.sSUnidadReceptora, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('serviciosocialApp:sSUnidadReceptoraUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.altaReg = false;
        vm.datePickerOpenStatus.bajaReg = false;
        vm.datePickerOpenStatus.ultActReg = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
